
import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'app-la-proposal-view',
	templateUrl: './la-proposal-view.component.html'
})

export class LaProposalViewComponent implements OnInit {

	@Input('proposalID') proposalID: string = "";
	@Input('accountClientID') accountClientID: string = "";
	@Input('profileUser') profileUser: string = "";
	@Input('segmentoID') segmentoID: string = "";

	constructor() {
	}

	ngOnInit() {
		console.log('proposalID', this.proposalID);
	}

}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/proposal-view-modal/LAproposal-view/la-proposal-view.component.ts